import { IntlShape } from "react-intl"
import { OptionMetricSelect, MetricName } from "./interfaces"
import { isFeatureEnabled } from "config/feature-flags"
import {
	METRIC_SALES_SELECT_FEATURE_FLAG_ID,
	METRIC_UNITS_SELECT_FEATURE_FLAG_ID,
	METRIC_TRANSACTIONS_SELECT_FEATURE_FLAG_ID,
	METRIC_CLIENTS_SELECT_FEATURE_FLAG_ID,
	METRIC_PENETRATION_SELECT_FEATURE_FLAG_ID,
	METRIC_PURCHASE_FRECUENCY_SELECT_FEATURE_FLAG_ID,
	METRIC_ITEMS_PER_VISIT_SELECT_FEATURE_FLAG_ID,
	METRIC_AVG_PRICE_SELECT_FEATURE_FLAG_ID,
	METRIC_AVG_SPEND_SELECT_FEATURE_FLAG_ID,
	METRIC_AVG_TICKET_SELECT_FEATURE_FLAG_ID,
	METRIC_STORES_SELLING_SELECT_FEATURE_FLAG_ID,
} from "../../constants"
export const createOptionsMetricSelect = (
	options: Array<OptionMetricSelect>,
	intl: IntlShape
) => {
	const messageId =
		"phronesis.transactional.application.commercial.benchmark.metric.select"
	return options
		.filter((option) => option.isVisible)
		.map(({ code, metric }) => ({
			code: code,
			name: intl.formatMessage({ id: messageId }, { metric }),
		}))
}

export const CODE_OPTIONS = {
	SALES: "sales" as MetricName,
	UNITS: "units" as MetricName,
	TRANSACTIONS: "transactions" as MetricName,
	CLIENTS: "clients" as MetricName,
	PENETRATION: "penetration" as MetricName,
	PURCHASE_FRECUENCY: "purchase-frequency" as MetricName,
	AVG_SPEND: "average-spend" as MetricName,
	AVG_TICKET: "average-ticket" as MetricName,
	AVG_PRICE: "average-price-per-item" as MetricName,
	ITEMS_PER_VISIT: "items-per-visit" as MetricName,
	STORES_SELLING: "stores-selling" as MetricName,
}

export const METRIC_OPTIONS: Array<OptionMetricSelect> = [
	{
		code: CODE_OPTIONS.SALES,
		metric: "sales",
		isVisible: isFeatureEnabled(METRIC_SALES_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.UNITS,
		metric: "units",
		isVisible: isFeatureEnabled(METRIC_UNITS_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.TRANSACTIONS,
		metric: "transactions",
		isVisible: isFeatureEnabled(METRIC_TRANSACTIONS_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.CLIENTS,
		metric: "clients",
		isVisible: isFeatureEnabled(METRIC_CLIENTS_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.PENETRATION,
		metric: "penetration",
		isVisible: isFeatureEnabled(METRIC_PENETRATION_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.PURCHASE_FRECUENCY,
		metric: "purchase_frequency",
		isVisible: isFeatureEnabled(
			METRIC_PURCHASE_FRECUENCY_SELECT_FEATURE_FLAG_ID
		),
	},
	{
		code: CODE_OPTIONS.ITEMS_PER_VISIT,
		metric: "items_per_visit",
		isVisible: isFeatureEnabled(METRIC_ITEMS_PER_VISIT_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.AVG_PRICE,
		metric: "avg_price",
		isVisible: isFeatureEnabled(METRIC_AVG_PRICE_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.AVG_SPEND,
		metric: "avg_spend",
		isVisible: isFeatureEnabled(METRIC_AVG_SPEND_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.AVG_TICKET,
		metric: "avg_ticket",
		isVisible: isFeatureEnabled(METRIC_AVG_TICKET_SELECT_FEATURE_FLAG_ID),
	},
	{
		code: CODE_OPTIONS.STORES_SELLING,
		metric: "stores_selling",
		isVisible: isFeatureEnabled(METRIC_STORES_SELLING_SELECT_FEATURE_FLAG_ID),
	},
]

export const getMetricNameForInsight = (
	metricName: string,
	insight: string,
	subMetric = ""
) => `${metricName}${insight}${subMetric}`
